import React from 'react';
import PropTypes from 'prop-types';

const LockIcon = () => (
  <svg width={21} height={26} viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="lock-icon">
    <path
      className="outline"
      d="M20 9.985H1v15h19v-15zM4.886 9.538S3.939.89 11.025 1.001c5.748-.056 5.58 8.816 5.58 8.816"
      stroke="#fff"
      strokeWidth={2}
    />
    <path className="dot" d="M10.5 19a2 2 0 100-4 2 2 0 000 4z" fill="#fff" />
  </svg>
);

LockIcon.propTypes = {};

export default LockIcon;
